import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["notificationRow pointer", { new: !_ctx.item.readOn }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
  }, [
    _createVNode(_component_localized_text, {
      localizedKey: "Nuovo messaggio in chat da ",
      text: "Nuovo messaggio in chat da "
    }),
    _cache[1] || (_cache[1] = _createTextVNode(" ")),
    _createElementVNode("b", null, _toDisplayString(_ctx.item.author.name), 1)
  ], 2))
}